export default "__VITE_ASSET__CVADPKn8__"